/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Preferences_Save_FailedInputs */

const en_user_preferences_save_failed = /** @type {(inputs: User_Preferences_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save preferences`)
};

const es_user_preferences_save_failed = /** @type {(inputs: User_Preferences_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron guardar las preferencias`)
};

/**
* | output |
* | --- |
* | "Failed to save preferences" |
*
* @param {User_Preferences_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const user_preferences_save_failed = /** @type {((inputs?: User_Preferences_Save_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Preferences_Save_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_preferences_save_failed(inputs)
	return es_user_preferences_save_failed(inputs)
});